import Rail from '../../classes/rail';
import Recording from '../../types/enums/recording';
import RecordingClass from '../../classes/record';
import { IRecordIdentifier } from '../../types/interfaces/record';
import { reload } from '../../store/slices/floatingMenu.slice';
import { store } from '../../store/store';
import {
  setFinishedRecordings,
  setIdentifiers,
  setPendingRecordings,
} from '../../store/slices/recordings.slice';

function updateRecordings(data: IRecordIdentifier[] | Rail[], type: Recording) {
  switch (type) {
    case Recording.Finished:
      const finishedData: RecordingClass[] = [];
      (data as Rail[]).forEach((item) => {
        item.data.forEach((event) => {
          finishedData.push(
            new RecordingClass(event?.eventId, Recording.Finished)
          );
        });
      });
      store.dispatch(setFinishedRecordings(finishedData));
      break;
    case Recording.Identifier:
      store.dispatch(setIdentifiers(data as IRecordIdentifier[]));
      break;
    case Recording.Pending:
      const pendingData: RecordingClass[] = [];
      (data as Rail[]).forEach((item) => {
        item.data.forEach((event) => {
          pendingData.push(
            new RecordingClass(event?.eventId, Recording.Pending)
          );
        });
      });
      store.dispatch(setPendingRecordings(pendingData));
      break;
  }
  store.dispatch(reload());
}

export default updateRecordings;
